<template lang="pug">
auth-method(
  v-bind="$attrs"
  v-on="$listeners"
  v-slot="{ loading, auth }"
)
  template(v-if="loading")
    .py-6.d-flex.flex-column.align-center.gap-32
      h2 Авторизируемся...
      v-progress-circular(
        :size="64"
        :width="6"
        indeterminate
        color="ui-primary"
      )
  template(v-else)
    template(v-if="!credentials")
      auth-services-list(@auth="auth")
      user-agreement-text.text-center.mt-3
      divider-text.my-6(text="или")
      dv-btn(
        text
        block
        @click="credentials = true"
      ) Войти с использованием логина и пароля
    template(v-else)
      p.ui-body-1.opacity-70.mb-2 Можно использовать логин и пароль ПФДО
      auth-credentials-form(
        @auth="auth"
      )
      divider-text.my-4(text="или")
      auth-services-list(@auth="auth")
      user-agreement-text.text-center.mt-4
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import AuthMethod from '../AuthMethod.vue';
import AuthServicesList from '../Lists/AuthServicesList.vue';
import UserAgreementText from '../Texts/UserAgreementText.vue';
import DividerText from '@/packages/ui/components/texts/DividerText.vue';
import AuthCredentialsForm from './AuthCredentialsForm.vue';

export default {
  components: {
    AuthServicesList,
    UserAgreementText,
    DividerText,
    AuthCredentialsForm,
    AuthMethod,
    DvBtn,
  },
  data() {
    return {
      credentials: false,
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped></style>
